import styled from 'styled-components';
import { theme } from '../globalStyle/global-styles';

export const CopyButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 12px;
  border-radius: 8px;
  border: 0.5px solid ${theme.colours.newOutline};
  width: fit-content;
  height: 30px;
  @media (max-width: 767px) {
    width: 100%;
    justify-content: space-between;
  }

  button {
    &:hover {
      background-color: transparent;
    }
  }
  p {
    font-size: 14px;
    color: ${theme.colours.black_2};
    margin-left: 0.5rem;
    font-weight: 400;
    line-height: 22px;
  }
`;
